import { useQuery } from '@tanstack/react-query';
import { concat } from 'lodash';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

import { mapLocationGroups } from './helpers';

export const useGetLocationGroups = (filters: string[] = [], enabled = true) =>
  useQuery({
    queryKey: queryKeys.locationGroups.all(filters),
    queryFn: () => fetchLocationGroups(filters),
    enabled: enabled,
  });

export const fetchLocationGroups = async (filters: string[] = []) => {
  const queries = concat(filters, ['pageSize=0']);
  const url = `/locationGroups${generateQuery(['layoutTypes'], queries)}`;

  const response = await requestCCApi({ url });

  return mapLocationGroups(response);
};
